module.exports = __webpack_public_path__ + "assets/img/1331587607178_.pic_hd.5eb2ff7d.jpg";